import React, { useState } from 'react';
import { FaEye } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Button, Col, Container, Input, NavLink, Row } from 'reactstrap';
import AuthFunctions from '../services/AuthService';
import Session from './Session';


function Login(props) {

    const [passwordType, setPasswordType] = useState('password');
    const [loggingIn,setLoggingIn] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [usernameRequired, setUsernameRequired] = useState(false);
    const [passwordRequired, setPasswordRequired] = useState(false);
    const [signinFailed, setSigninFailed] = useState(false);
    const [usernameMissing, setUsernameMissing] = useState(false);
    const [passwordMissing, setPasswordMissing] = useState(false);


    const checkAuthenticated = async () => {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (isAuthenticated) {
            window.location.href = '/';
            //props.history.push('/');
        }
    }

    //async componentDidMount() {
    //    document.getElementsByTagName('html')[0].className = "background-login";
    //}

    const validateInfo = () => {
        let tempUsernameMissing = false
        let tempPasswordMissing = false

        if (username.trim().length === 0) {
            tempUsernameMissing = true;
        }

        if (password.trim().length === 0) {
            tempPasswordMissing = true;
        }

        //setState({ usernameMissing: usernameMissing, passwordMissing: passwordMissing, loggingIn: false, signinFailed: false });
        setUsernameMissing(tempUsernameMissing);
        setPasswordMissing(tempPasswordMissing)
        setLoggingIn(false);
        setSigninFailed(false)

        return !tempUsernameMissing && !tempPasswordMissing;
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (validateInfo()) {
                submitLogin();
            }
        }
    }

    const submitLogin = async () => {
        setLoggingIn(true)
        if (validateInfo()) {
            var tokenData = await AuthFunctions.signInAsync(username, password);

            setLoggingIn(false)

            if (tokenData.token === null || tokenData.token.length === 0) {
                setSigninFailed(true)
            }
            else {
                setSigninFailed(false)
                Session.setUserSession(tokenData.userName, tokenData.token, tokenData.userId, tokenData.userRoles);
                window.location.href = '/';
            }
        }
    }

    return (
        <>
            <div className='main' style={{ marginTop: '20px' }}>
                <Container>
                    <Row className="row text-center" style={{ justifyContent: "center" }}>
                        <div className="login-content" style={{display: "flex", justifyContent: "center"}}>
                            {/*                            <img src="logo.jpg" alt="logo" style={logo} />*/}
                            <section style={{ margin: '20px' }}>
                                {signinFailed &&
                                    <span style={{ color: 'red' }}>Username or password is incorrect!</span>
                                }
                                <div className="form-group" style={{marginBottom: ".5rem"}}>
                                    <Input
                                        type='text'
                                        onChange={(e) => { setUsername(e.target.value); setUsernameMissing(false) }}
                                        className='form-control'
                                        value={username}
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        placeholder='Username'
                                        style={{ width: '300px' }}
                                    />
                                    {usernameMissing &&
                                        <span style={{ color: 'red' }}>Username is required!</span>
                                    }
                                    <span asp-validation-for="Input.Email" className="text-danger"></span>
                                </div>
                                <div className="form-group" style={{marginBottom: ".5rem"}}>
                                    <Input
                                        type={passwordType}
                                        onChange={(e) => { setPassword(e.target.value); setPasswordMissing(false) }}
                                        className='form-control'
                                        value={password}
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        placeholder='Password'
                                        style={{ width: '300px' }}
                                    />
                                    <FaEye className="password-eye"
                                        style={{ marginRight: '15px', cursor: 'pointer', float: 'right', marginTop: '-25px' }}
                                        onClick={() => {
                                            var type = passwordType === 'password' ? 'text' : 'password';
                                            setPasswordType(type)
                                        }}
                                    />
                                    {passwordMissing &&
                                        <span style={{ color: 'red' }}>Password is required!</span>
                                    }
                                    <span asp-validation-for="Input.Password" className="text-danger"></span>
                                </div>
                                <Row style={{marginBottom: ".5rem"}}>
                                    <Col style={{ textAlign: 'center' }}>
                                        <Button className='standardButton btn btn-primary' disabled={loggingIn} style={{ width: '100px' }} onClick={() => {
                                            submitLogin();
                                        }}>
                                            Log In
                                        </Button>
                                    </Col>
                                </Row>
                                {/* <Row style={{marginBottom: ".5rem"}}>
                                    <Col>
                                        <p className="pull-left">
                                            <NavLink tag={Link} className="forgot-link" to={'/forgot'}>Forgot your password?</NavLink>
                                        </p>
                                    </Col>
                                </Row> */}
                            </section>
                        </div>
                    </Row>
                </Container>
            </div>
        </>
    )

}
export default Login